window._ = require('lodash')
import { createApp } from 'vue'

try {
    window.bootstrap = require('bootstrap')
    window.download = require('downloadjs')
    window.toastr = require('toastr')
} catch (e) {}

/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

window.axios = require('axios')

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest'

/**
 * Echo exposes an expressive API for subscribing to channels and listening
 * for events that are broadcast by Laravel. Echo and event broadcasting
 * allows your team to easily build robust real-time web applications.
 */

import Echo from 'laravel-echo'
if (process.env.MIX_SOCKETS_ENABLED) {
    window.Pusher = require('pusher-js')

    window.Echo = new Echo({
        broadcaster: 'pusher',
        key: process.env.MIX_PUSHER_APP_KEY,
        wsHost: process.env.MIX_PUSHER_HOST,
        wsPort: process.env.MIX_PUSHER_PORT,
        wssPort: process.env.MIX_PUSHER_PORT,
        // cluster: process.env.MIX_PUSHER_APP_CLUSTER,
        forceTLS: false,
        encrypted: true,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
    })
}

/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const app = createApp({})

// const files = require.context('./', true, /\.vue$/i)
// files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

app.component('documents', require('./components/DocumentComponent.vue').default)
app.component('uploaded-files', require('./components/UploadedFiles.vue').default)
app.component('signature', require('./components/SignatureComponent.vue').default)
app.component('decline-onboarding', require('./components/DeclineOnboardingComponent.vue').default)
app.component('mutations', require('./components/MutationsComponent.vue').default)
app.component('worked-hours', require('./components/WorkedHours.vue').default)
app.component('text-editor', require('./components/TextEditor').default)
app.component('planned-shifts', require('./components/PlannedShifts').default)
app.component('enrollment-conflicts', require('./components/EnrollmentConflicts').default)
app.component('past-shifts', require('./components/PastShiftsComponent').default)
app.component('shift-schedule', require('./components/shifts/ScheduleComponent.vue').default)
app.component('vue-multiselect', require('vue-multiselect').default)
app.component('contract-modal', require('./components/contracts/ContractModal.vue').default)
app.component('index-table', require('./components/tables/IndexTable.vue').default)
app.component('international-telephone-input', require('./components/shared/InternationalTelephoneInput.vue').default)
app.component('assign-contact-locations', require('./components/contacts/AssignContactLocations.vue').default)

app.directive('can', require('./directives/authorisation').default)

/**
 * Add Laravel translations support to Vue
 */
import Lang from 'lang.js'
import translations from '@/translations/messages.js'
const html = document.querySelector('html')
const currentLocale = html.getAttribute('lang').replace('-', '_')
const fallbackLocale = html.getAttribute('lang-fallback').replace('-', '_')
const trans = new Lang({ messages: translations, locale: currentLocale, fallback: fallbackLocale })

import mitt from 'mitt'
const emitter = mitt()

app.config.globalProperties.$trans = trans
app.config.globalProperties.$mitt = emitter

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

app.mount('#app')

export {
    trans,
}
